define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/action",
	"csi/action/FormData",
	"csi/action/SelectOneController",
	"csi/def",
	"csi/def/ViewRef",
	"csi/locale",
	"csi/reflection",
	"csi/xml",
	"csi/xml/Query"
], function(declare,lang,action,FormData,SelectOneController,def,ViewRef,locale,reflection,xml,Query) {

	return declare(SelectOneController, {
		_bMerge: false,
		_bReplace: false,
		_sampleFormData: null,
		_masterMaterial: null,

		/**
		 * @override
		 * Change title of dialog when merging two hidden materials
		 */
		onCreatePopupDialogParams: function(dialogParams) {
			if (this._sampleFormData) {
				dialogParams.title = locale.typeAction(this._masterMaterial.$Type, "PromoteMaterial");
			}
		},		

		process: function() {
			// summary: process action
			if (this._masterMaterial) {
				// if form has now been processed, then ready to write request
				this.inherited(arguments);
				return;
			}

			// test placement members to determine if confirmation prompt is needed before continuing
			var	sample = this.m_formData.getSelectedNode();
			var	placement = this.getNode();
			var	placementMaterial = this.m_cache.get(placement.Actual || placement.MPCMaterial);
			var	buttons, params, suffix;

			if (sample && placementMaterial) {
				var cache = this.m_cache;
				var sampleSource = cache.get(sample.__Parent__);
				var sampleSourcing = cache.get(sampleSource.__Parent__);
				var sampleMaterial = cache.get(sampleSourcing.__Parent__);
				var placementSourcing = cache.get(placementMaterial.ProductSourcing);
				var placementSource = cache.get(placementSourcing.ProductSources[0]);
				var placementSample = (placementSource != null) ? cache.get(placementSource.Samples[0]) : sample;

				if (placementMaterial.Hidden && sampleMaterial.Hidden) {
					// prompt to merge and promote, or replace
					buttons =["MaterialPlanPromote", "MaterialPlanReplace", "C"];
					params = [placementSample.$Name, sample.$Name];
					suffix = "PromoteReplace";
					this._masterMaterial = placementMaterial;
				} else if (placementMaterial.Hidden) {
					// prompt to merge and promote, or replace
					buttons =["MaterialPlanMerge", "MaterialPlanReplace", "C"];
					params = [placementSample.$Name, sampleMaterial.$Name];
					suffix = "MergeReplace";
					this._masterMaterial = placementMaterial;
				} else {
					// prompt to merge
					params = [sample.$Name, placementMaterial.$Name];
					suffix = "Merge";
				}
			}

			if (suffix) {
				this.confirmAction({
					buttons: buttons,
					message: this.getString(action.SUFFIX_CONFIRM + suffix, params),
					onResponse: lang.hitch(this, this._processContinue)
				});
			} else {
				this.inherited(arguments);
			}
		},

		toWriterRequest: function() {
			// summary: add parameter if replacing
			var	fd = this.m_formData;

			// before writing first request, replace form data with original
			if (this._sampleFormData) {
				this.m_formData = this._sampleFormData;
			}

			var	call = this.inherited(arguments);

			if (this._bReplace) {
				// add special parameter to replace selected sample
				call.addParameter("Replace", xml.ATTR_BOOLEAN, "true");
			} else if (this._sampleFormData) {
				// write form fields
				this.toWriterFields(this._masterMaterial.$URL, fd);
				this.m_writer.validateNode(this._masterMaterial.$URL, true);
			}

			return call;
		},

		_getFixedFilters: function() {
			// summary: apply view filters based on current state of placement (colorway)
			var	q = new Query();
			var	path = reflection.PATH_PARENT + "/" + reflection.PATH_PARENT + "/" + reflection.PATH_PARENT;
			var	placement = this.getNode();
			var	material = this.m_cache.getNode(placement.Actual || placement.MPCMaterial);
			if (material) {
				// if material is specified, then query for samples matching the material type
				q.RefAttr("ProductType", xml.OP_EQUALS, material.ProductType, path);

				if (material.Hidden) {
					// if material is specified and hidden, then do not allow them to select the same material
					q.Node(xml.PROP_URL, xml.OP_NOT_EQUALS, material.$URL, path);
				} else {
					// if material is specified and not hidden, then can only query for samples with hidden materials
					q.Attr("Hidden", xml.OP_EQUALS, true, path);
				}
			}

			q.Attr("Active", xml.OP_EQUALS, true, path);
			q.Attr("OKforStyleBOM", xml.OP_EQUALS, true, path);
			return q.getElements();
		},

		_onMerge: function() {
			// summary: handle merge of two hidden materials - popup material form before sending request (basically an Edit action)
			var	vr = lang.mixin(new ViewRef(), {m_id: def.DEFAULT_FORM_ID, m_url: this._masterMaterial.$URL});
			this._sampleFormData = this.m_formData;
			this.m_formData = new FormData(this);
			this.m_formData.setNode(this._masterMaterial);
			this.openDialog(this.getActionView(vr));
		},

		_processContinue: function(/*String*/key) {
			// summary: continue processing based on confirmation response
			if (key == "MaterialPlanPromote") {
				// use timeout so confirmation dialog has time to close before opening new dialog
				this.postProcessProxy(true);
				setTimeout(lang.hitch(this, this._onMerge), 500);
				return;
			} else if (key == "MaterialPlanReplace") {
				// replace selected material with that from selected sample
				this._bReplace = true;
			} else if ((key == "Y") || (key == "MaterialPlanMerge")) {
				// handle merge of promoted material vs. hidden material
				this._bMerge = true;
			} else {
				this.postProcess();
				return;
			}

			this.setProgress();
			SelectOneController.prototype.process.call(this);
		},

		postProcessSuccess: function() {
			// summary: refresh table row(s) based on whether or not you are merging
			return this._bMerge ? this.widget.refreshDataRows() : this.widget.redrawNode(this.m_element);
		}
	});
});